import React, { ReactNode } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const StripePaymentWrapper = ({ children }: { children: ReactNode }) => {
  const metaElement = document.querySelector(
    'meta[name="stripe_publishable_key"]',
  ) as HTMLMetaElement;
  const stripeKey = metaElement.content;
  const stripePromise = loadStripe(stripeKey);

  return (
    <Elements
      stripe={stripePromise}
      options={{
        mode: 'setup',
        currency: 'usd',
        appearance: {
          theme: 'stripe' as const,
          variables: {
            colorPrimary: '#0570de',
            colorBackground: '#ffffff',
          },
        },
        paymentMethodOptions: {
          us_bank_account: {
            verification_method: 'instant',
          },
        },
      }}
    >
      {children}
    </Elements>
  );
};

export default StripePaymentWrapper;
